exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "footer[data-v-2c70f4a6]{padding-top:80px}footer .image[data-v-2c70f4a6]{width:125px}footer .text[data-v-2c70f4a6]{padding:25px}footer .copyright[data-v-2c70f4a6]{padding:14px 10px;background:#2f1d0d}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2c70f4a6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/Footer.vue
// module id = 4vNr
// module chunks = 1